import { NextSeo } from "next-seo";
import { DocumentLists } from "@nju/feature-portal-documents";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function RegulationsAndPrices() {
  return (
    <LayoutWrapper>
      <NextSeo title="regulaminy i cenniki nju | nju.pl" />
      <Header />
      <BlockContent spacing="l">
        <DocumentLists
          title="aktualne regulaminy i cenniki"
          validity="EFFECTIVE"
        />
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
